// トグル(アコーディオン)表示
import commonClass from "./commonClass";

export default class selectTagClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$del = $('.js-tag-del');
    this._$add = $('.js-tag-add');
    this._$tmp = $('.article_tab_tbl_tmp');
    this._rt = '.article_tab_cont';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;
    // 要素削除
    cls._$del.on('click', function(){
      var me = this;
      $(me).remove();
    });

    // 要素追加
    cls._$add.on('click', function(){
      var me = this;
      var tag_text = '<span>' + $(me).children().text() + '</span>';
      var $cln_html = cls._$tmp.children().clone(true).html(tag_text);
      $(me).parents(cls._rt).find('.js-del').prepend($cln_html);
      $(me).remove();
    });
  }

}